import React from 'react';
import {Star, Store} from "lucide-react";
import {SingleProductEnum} from "@/constants/commerce-enum";
import {IProductDetailsProps} from "@/interface/components/product/product-details";
import Link from "next/link";

interface IProps {
    data: IProductDetailsProps;
}

const SellerInfo: React.FC<IProps> = ({data}) => {
    return (
        <div
            className="w-full h-[76px] flex flex-wrap border-b  border-gray-200 items-center justify-between">
            <div className="w-2/3 items-center line-clamp-1 text-nowrap flex gap-1 text-base">
                <Store className={"text-purple-600"}/>
                <span className="text-gray-400">{SingleProductEnum.seller} :</span>
                <Link href={`/seller/${data?.productItem?.seller?.slug}`} prefetch={false}>
                    <strong>{data?.productItem?.seller?.title}</strong>
                </Link>
            </div>
            {
                data?.product?.rate_average > 0 ? (
                    <div className="w-1/3 flex items-center justify-end gap-1">
                        <div className={"w-7 h-7"}>
                            <Star className={"text-amber-400 fill-amber-400"}/>
                        </div>
                        <div>
                            <span
                                className="text-lg font-bold">{data?.product?.rate_average?.toLocaleString("fa")}</span>
                            <span className="text-sm text-gray-400 ps-1">
                                ({SingleProductEnum?.star}
                                <span className="px-0.5">
                                    {
                                        data?.productComments ? (Object.values(data?.productComments)?.length)?.toLocaleString("fa") : null
                                    }
                                </span>
                                {SingleProductEnum?.customer})
                            </span>
                        </div>
                    </div>
                ) : null
            }

        </div>
    );
};

export default SellerInfo;